import './style.scss';

export default function Expertise(){
    return <div className='expertiseContainerGlobal'>
<h1 className='expertiseTitle'>Notre expertise</h1>
<div className='expertiseDetail'>
    <div className='bloc1'>
    <div className='expertise1'>
    <h3 className='expertiseTitleDetail'>DIRECTION ARTISTIQUE </h3>
    <div className='txtExpertise'> <strong>Louise une designer graphique expérimentée </strong>est capable de créer des logos, des graphiques, des illustrations et des designs pour l'identité visuelle de votre société.</div>
</div>
<div className='expertise1'>
    <h3 className='expertiseTitleDetail'>DEVELOPPEMENT WEB </h3>
    <div className='txtExpertise'> <strong>Mélanie une développeuse web est capable de construire des sites web et des applications</strong> en utilisant des technologies web modernes comme HTML, CSS, JavaScript, React, Redux.</div>
</div></div>
<div className='bloc2'>
<div className='expertise1'>
    <h3 className='expertiseTitleDetail'>MARKETING </h3>
    <div className='txtExpertise'><strong>Louise et Mélanie ont une bonne compréhension du marketing pour aider nos clients</strong> à se différencier de leurs concurrents et à atteindre leur public cible.</div>
</div>
<div className='expertise1'>
    <h3 className='expertiseTitleDetail'>TENDANCES ACTUELLES </h3>
    <div className='txtExpertise'><strong>Louise et Mélanie sont à la pointe des tendances actuelles en matière de design et de développement </strong>pour offrir des services de qualité supérieure et répondre aux besoins de nos clients..</div>
</div></div>

</div>

    </div>
}